import { useTranslation } from 'react-i18next';
import { Alert, Button } from '../components/kit.tsx';
import { usePageTitle } from '../lib/format.ts';
import { isAppleMobile, isStandalone } from '../lib/push.ts';
import { usePwa } from '../lib/pwa.tsx';

/**
 * Install guide (roadmap 3.1): Chrome and Edge get their own install prompt (the button); iOS and iPadOS
 * have none, so the guide walks through Share → Add to Home Screen (needed there for notifications too).
 */
export function Install() {
  const { t } = useTranslation();
  const pwa = usePwa();
  usePageTitle(t('install.title'));
  const platforms = [
    { id: 'ios', steps: ['install.ios1', 'install.ios2', 'install.ios3'] },
    { id: 'android', steps: ['install.android1', 'install.android2'] },
    { id: 'desktop', steps: ['install.desktop1', 'install.desktop2'] },
  ];
  const first = isAppleMobile() ? 'ios' : /Android/.test(navigator.userAgent) ? 'android' : 'desktop';
  platforms.sort((a, b) => (a.id === first ? -1 : b.id === first ? 1 : 0));
  return (
    <div className="stack">
      <h1>{t('install.title')}</h1>
      {isStandalone() || pwa.installed ? <Alert tone="success"><p>{t('install.already')}</p></Alert> : null}
      <p>{t('install.summary')}</p>
      {pwa.canInstall ? <Button onClick={() => void pwa.install()}>{t('install.button')}</Button> : null}
      {platforms.map((p) => (
        <section className="card" key={p.id} aria-labelledby={`install-${p.id}`}>
          <h2 id={`install-${p.id}`}>{t(`install.${p.id}Title`)}</h2>
          <ol>{p.steps.map((s) => <li key={s}>{t(s)}</li>)}</ol>
        </section>
      ))}
    </div>
  );
}
